module.exports = __webpack_public_path__ + "images/fed6e809601e3ba6db9bb13b1f7f66b4.png";